import React from 'react'
import { urlsImg } from '../../../utils/urlsImages'
import TextTitle from '../../infoAboutMe/title-h3/TextTitle'
import { SkillsCategory } from './skills-category/SkillsCategory'
import { Skills, SkillsContainer } from './styles'

export const SkillsArea = () => {
  return (
    <SkillsContainer>
      
      <TextTitle
        text="Skills"
        stylesElement={{
          fontSize: "2rem",
          textAlign: "right",
          marginBottom: "20px",
          fontSize_lg: "3rem"
        }}
      />

      <Skills>
        
        <SkillsCategory
          title="Frontend"
          category="frontend"
          arrayUrls={urlsImg.frontend}
        />

        <SkillsCategory
          title="Backend"
          category="backend"
          arrayUrls={urlsImg.backend}
          rigth="true"
        />

        <SkillsCategory
          title="Others"
          category="others"
          arrayUrls={urlsImg.others}
        />

      </Skills>

    </SkillsContainer>
  )
}
